var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71875 10.875C5.11458 10.875 5.44792 10.7396 5.71875 10.4688C5.98958 10.1979 6.125 9.86458 6.125 9.46875V7.125H8V5.875H5.5V8.29688C5.38542 8.21354 5.26292 8.15354 5.1325 8.11688C5.00208 8.08021 4.86417 8.06208 4.71875 8.0625C4.32292 8.0625 3.98958 8.19792 3.71875 8.46875C3.44792 8.73958 3.3125 9.07292 3.3125 9.46875C3.3125 9.86458 3.44792 10.1979 3.71875 10.4688C3.98958 10.7396 4.32292 10.875 4.71875 10.875ZM1.75 12.75C1.40625 12.75 1.11188 12.6275 0.866876 12.3825C0.621876 12.1375 0.499584 11.8433 0.500001 11.5V1.5C0.500001 1.15625 0.622501 0.861876 0.867501 0.616876C1.1125 0.371876 1.40667 0.249584 1.75 0.250001H6.75L10.5 4V11.5C10.5 11.8438 10.3775 12.1381 10.1325 12.3831C9.8875 12.6281 9.59333 12.7504 9.25 12.75H1.75ZM6.125 4.625H9.25L6.125 1.5V4.625Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.a4b1a36071681a6531f59141ef697c8c.svg";
export { ForwardRef as ReactComponent };